export default __webpack_public_path__ + "static/media/img-3.7e87b3b1.png";